import { render, staticRenderFns } from "./AdminIndustries.vue?vue&type=template&id=80544f6c&"
import script from "./AdminIndustries.vue?vue&type=script&lang=js&"
export * from "./AdminIndustries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports